export default __webpack_public_path__ + "static/media/UnitedIndia.924cec56.svg";